/* eslint-disable no-useless-escape */
export const env = {
  product: {},
  dev: {}
};
